module.exports = __webpack_public_path__ + "static/_0009_VARNISH-7b3e26bda38cad28da51e1a30cb5af75.jpg";